import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, X, Star, ChevronDown, ChevronUp } from 'lucide-react';
const TestimonialCard = ({
  name,
  role,
  quote,
  delay
}: {
  name: string;
  role: string;
  quote: string;
  delay: number;
}) => <motion.div initial={{
  opacity: 0,
  y: 20
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true
}} transition={{
  delay,
  duration: 0.5
}} className="bg-[#0a0a0a] border border-[#222] p-6 rounded-xl flex flex-col h-full" data-id="element-192">
    <div className="flex gap-1 mb-4" data-id="element-193">
      {[...Array(5)].map((_, i) => <Star key={i} size={14} className="fill-[#d4af37] text-[#d4af37]" data-id="element-194" />)}
    </div>
    <p className="text-[#8a8578] italic text-sm mb-6 flex-grow leading-relaxed" data-id="element-195">
      "{quote}"
    </p>
    <div className="mt-auto" data-id="element-196">
      <p className="text-[#f5f0e8] font-bold text-sm" data-id="element-197">{name}</p>
      <p className="text-[#555] text-xs uppercase tracking-wide" data-id="element-198">{role}</p>
    </div>
  </motion.div>;
const FAQItem = ({
  question,
  answer
}: {
  question: string;
  answer: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-[#222]" data-id="element-199">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 flex justify-between items-center text-left group" data-id="element-200">
        <span className={`text-lg font-medium transition-colors ${isOpen ? 'text-[#d4af37]' : 'text-[#f5f0e8] group-hover:text-[#d4af37]'}`} data-id="element-201">
          {question}
        </span>
        {isOpen ? <ChevronUp className="text-[#d4af37]" data-id="element-202" /> : <ChevronDown className="text-[#8a8578]" data-id="element-203" />}
      </button>
      <AnimatePresence data-id="element-204">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="overflow-hidden" data-id="element-205">
            <p className="text-[#8a8578] pb-6 leading-relaxed" data-id="element-206">{answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
};
export function OfferSection() {
  return <section id="comprar" className="w-full bg-[#050505] py-24 px-4 pb-40" data-id="element-207">
      <div className="max-w-5xl mx-auto" data-id="element-208">
        {/* INCLUSIONS */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-24" data-id="element-209">
          <div data-id="element-210">
            <h3 className="font-serif text-3xl text-[#f5f0e8] mb-8" data-id="element-211">
              Qué incluye el PDF
            </h3>
            <ul className="space-y-4" data-id="element-212">
              {['Las 4 leyes mentales aterrizadas al trading', 'Explicación mente consciente vs subconsciente', 'Semáforo verde/amarillo/rojo', 'Checklist de 1 minuto para entrar', 'PP-7 completo con respuestas de intervención', 'Guiones de 60 segundos para cortar venganza', 'Cierre de sesión para evitar espiral', 'Diario mínimo (5 preguntas)', 'Plan de 14 días de instalación'].map((item, i) => <li key={i} className="flex items-start gap-3 text-[#8a8578]" data-id="element-213">
                  <Check className="w-5 h-5 text-[#d4af37] flex-shrink-0" data-id="element-214" />
                  <span data-id="element-215">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="space-y-8" data-id="element-216">
            <div className="bg-[#0a0a0a] border border-[#222] p-6 rounded-lg" data-id="element-217">
              <h4 className="text-[#f5f0e8] font-medium mb-4 flex items-center gap-2" data-id="element-218">
                <Check className="w-4 h-4 text-green-500" data-id="element-219" /> Esto es para ti si:
              </h4>
              <ul className="space-y-2 text-sm text-[#8a8578]" data-id="element-220">
                <li data-id="element-221">• Rompes reglas después de ganar o perder</li>
                <li data-id="element-222">• Te cuesta cerrar sesión</li>
                <li data-id="element-223">• Te da vergüenza admitir que te saboteas</li>
                <li data-id="element-224">• Quieres convertirte en el trader que admiras</li>
              </ul>
            </div>

            <div className="bg-[#0a0a0a] border border-[#222] p-6 rounded-lg opacity-70" data-id="element-225">
              <h4 className="text-[#f5f0e8] font-medium mb-4 flex items-center gap-2" data-id="element-226">
                <X className="w-4 h-4 text-red-500" data-id="element-227" /> No es para ti si:
              </h4>
              <ul className="space-y-2 text-sm text-[#8a8578]" data-id="element-228">
                <li data-id="element-229">• Buscas señales o entradas mágicas</li>
                <li data-id="element-230">• Quieres evitar pérdidas a toda costa</li>
                <li data-id="element-231">• Quieres espiritualidad sin estructura</li>
                <li data-id="element-232">• No estás dispuesto a seguir un protocolo</li>
              </ul>
            </div>
          </div>
        </div>

        {/* TESTIMONIALS */}
        <div className="mb-24" data-id="element-233">
          <h3 className="text-center font-serif text-2xl text-[#f5f0e8] mb-12" data-id="element-234">
            Lo que dicen otros traders
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-235">
            <TestimonialCard name="Carlos M." role="Trader de Forex · 3 años" quote="Llevaba meses saboteándome después de cada racha ganadora. Subía tamaño, rompía reglas, y terminaba devolviendo todo. El PP-7 me dio algo que ningún curso me había dado: una respuesta mecánica para cuando la euforia aparece. En 14 días dejé de negociar conmigo mismo." delay={0} data-id="element-236" />
            <TestimonialCard name="Andrea R." role="Trader de Crypto · 1 año" quote="Lo que más me impactó fue darme cuenta de que mi problema no era la estrategia. Era que operaba para tapar ansiedad. Los guiones de RI-3 me cambiaron la forma de hablarme antes de cada sesión. Ahora cierro la plataforma sin culpa cuando el semáforo está en rojo." delay={0.1} data-id="element-237" />
            <TestimonialCard name="Miguel Á." role="Trader de Índices · 5 años" quote="Cinco años operando y seguía cayendo en venganza después de un stop. Este PDF es brutalmente honesto. No te vende humo. Te pone un espejo y te da herramientas reales. El diario de obediencia fue lo que finalmente me hizo ver que sí puedo confiar en mí." delay={0.2} data-id="element-238" />
          </div>
        </div>

        {/* PRICING */}
        <div className="max-w-2xl mx-auto text-center mb-24 bg-[#0a0a0a] border border-[#222] rounded-2xl p-8 md:p-12 relative overflow-hidden" data-id="element-239">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#b8942e] via-[#d4af37] to-[#e8c84a]" data-id="element-240"></div>

          <div className="inline-block p-1 rounded-full bg-gradient-to-r from-[#b8942e] to-[#e8c84a] mb-8" data-id="element-241">
            <div className="bg-[#050505] rounded-full px-6 py-2" data-id="element-242">
              <span className="text-[#d4af37] text-sm font-bold tracking-widest uppercase" data-id="element-243">
                Oferta de lanzamiento
              </span>
            </div>
          </div>

          <div className="flex flex-col items-center justify-center mb-6" data-id="element-244">
            <div className="flex items-center gap-3 mb-2" data-id="element-245">
              <span className="text-[#8a8578] text-xl line-through decoration-red-500/50" data-id="element-246">
                $17.99 USD
              </span>
              <span className="bg-red-900/30 text-red-400 text-xs font-bold px-2 py-1 rounded" data-id="element-247">
                -64%
              </span>
            </div>
            <h2 className="text-6xl md:text-8xl font-serif text-[#f5f0e8] font-bold" data-id="element-248">
              $6.39{' '}
              <span className="text-2xl md:text-4xl text-[#8a8578] font-normal" data-id="element-249">
                USD
              </span>
            </h2>
          </div>

          <p className="text-[#8a8578] text-lg mb-10 max-w-lg mx-auto" data-id="element-250">
            Es deliberadamente accesible. Porque el punto no es que pienses "qué
            caro". El punto es que pienses:{' '}
            <span className="text-[#f5f0e8]" data-id="element-251">
              "Es más caro seguir pagando el impuesto de mi impulsividad."
            </span>
          </p>

          <a href="https://pay.hotmart.com/I104339970M" target="_blank" rel="noopener noreferrer" className="inline-block w-full md:w-auto px-12 py-4 bg-gradient-to-r from-[#b8942e] via-[#d4af37] to-[#e8c84a] text-black font-bold text-lg tracking-wide rounded hover:shadow-[0_0_30px_rgba(212,175,55,0.4)] transition-all duration-300 transform hover:-translate-y-1" data-id="element-252">
            CONSIGUE TRADING EN PAZ
          </a>

          <p className="mt-4 text-xs text-[#555]" data-id="element-253">
            Entrega digital inmediata (PDF)
          </p>
        </div>

        {/* 14 DAY PLAN */}
        <div className="border-t border-[#222] pt-16 mb-24" data-id="element-254">
          <h3 className="text-center font-serif text-2xl text-[#f5f0e8] mb-12" data-id="element-255">
            La Regla de 14 Días
          </h3>
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-[#8a8578] max-w-4xl mx-auto" data-id="element-256">
            <div className="flex flex-col items-center gap-2" data-id="element-257">
              <span className="w-8 h-8 rounded-full border border-[#333] flex items-center justify-center text-[#d4af37]" data-id="element-258">
                1
              </span>
              <span data-id="element-259">Semáforo</span>
            </div>
            <div className="h-px w-8 bg-[#333] hidden md:block" data-id="element-260"></div>
            <div className="flex flex-col items-center gap-2" data-id="element-261">
              <span className="w-8 h-8 rounded-full border border-[#333] flex items-center justify-center text-[#d4af37]" data-id="element-262">
                2
              </span>
              <span data-id="element-263">Checklist</span>
            </div>
            <div className="h-px w-8 bg-[#333] hidden md:block" data-id="element-264"></div>
            <div className="flex flex-col items-center gap-2" data-id="element-265">
              <span className="w-8 h-8 rounded-full border border-[#333] flex items-center justify-center text-[#d4af37]" data-id="element-266">
                3
              </span>
              <span data-id="element-267">PP-7</span>
            </div>
            <div className="h-px w-8 bg-[#333] hidden md:block" data-id="element-268"></div>
            <div className="flex flex-col items-center gap-2" data-id="element-269">
              <span className="w-8 h-8 rounded-full border border-[#333] flex items-center justify-center text-[#d4af37]" data-id="element-270">
                4
              </span>
              <span data-id="element-271">Cierre</span>
            </div>
            <div className="h-px w-8 bg-[#333] hidden md:block" data-id="element-272"></div>
            <div className="flex flex-col items-center gap-2" data-id="element-273">
              <span className="w-8 h-8 rounded-full border border-[#333] flex items-center justify-center text-[#d4af37]" data-id="element-274">
                5
              </span>
              <span data-id="element-275">Diario</span>
            </div>
          </div>
        </div>

        {/* FAQ SECTION */}
        <div className="max-w-3xl mx-auto mb-24" data-id="element-276">
          <h3 className="text-center font-serif text-2xl text-[#f5f0e8] mb-12" data-id="element-277">
            Preguntas Frecuentes
          </h3>
          <div className="space-y-2" data-id="element-278">
            <FAQItem question="¿Es solo un PDF?" answer="Sí, y eso es intencional. No necesitas otro curso de 40 horas que no vas a terminar. Necesitas un sistema simple que puedas imprimir, pegar donde operas, y aplicar HOY. Trading en Paz está diseñado para ser una herramienta de uso diario, no contenido para consumir y olvidar." data-id="element-279" />
            <FAQItem question="¿Funciona para mi mercado (crypto, forex, acciones, índices)?" answer="Sí. El sabotaje emocional no distingue entre mercados. Si operas con dinero real y sientes presión, este sistema aplica. Los gatillos (FOMO, venganza, euforia) son universales." data-id="element-280" />
            <FAQItem question="¿Cuánto tiempo toma ver resultados?" answer="El plan está diseñado para 14 días. No vas a convertirte en otro trader de la noche a la mañana, pero en 14 días de aplicación consistente vas a notar algo poderoso: empiezas a verte diferente. Y cuando te ves diferente, operas diferente." data-id="element-281" />
            <FAQItem question="¿Esto reemplaza mi estrategia de trading?" answer="No. Trading en Paz no te dice cuándo entrar o salir del mercado. Te da el sistema mental para que EJECUTES tu estrategia sin sabotearte. Es el complemento que tu estrategia necesita para funcionar de verdad." data-id="element-282" />
            <FAQItem question="¿Por qué tan barato?" answer="Porque una sola sesión impulsiva te cuesta más que esto. El precio no es el punto. El punto es que dejes de pagar el impuesto invisible de tu impulsividad. Si $6.39 te parece mucho, piensa en cuánto te costó tu último trade de venganza." data-id="element-283" />
            <FAQItem question="¿Qué pasa si no me funciona?" answer="Si aplicas el protocolo 14 días y no notas ningún cambio en tu forma de operar, el problema probablemente no es emocional — es estratégico. Pero si te reconoces en esta página, este PDF fue escrito para ti." data-id="element-284" />
          </div>
        </div>

        {/* CLOSING */}
        <div className="bg-[#0a0a0a] rounded-2xl overflow-hidden flex flex-col md:flex-row border border-[#222]" data-id="element-285">
          <div className="md:w-1/2 relative min-h-[300px]" data-id="element-286">
            <img src="https://cdn.magicpatterns.com/uploads/8BB53BHWVDSfnPogEn3tbw/Imagen_mocapck_actualizada.png" alt="Trader desk" className="absolute inset-0 w-full h-full object-cover opacity-80" data-id="element-287" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#0a0a0a] to-transparent" data-id="element-288"></div>
          </div>
          <div className="md:w-1/2 p-8 md:p-12 flex flex-col justify-center" data-id="element-289">
            <h3 className="font-serif text-2xl text-[#f5f0e8] mb-4" data-id="element-290">
              Tu mayor riesgo es esta frase: <br data-id="element-291" />
              <span className="text-[#d4af37]" data-id="element-292">
                "Yo sé lo que tengo que hacer… pero no lo hago."
              </span>
            </h3>
            <p className="text-[#8a8578] mb-8" data-id="element-293">
              Trading en Paz te da lo que faltaba: un puente entre el tú
              racional y el tú reactivo. Aplicalo 14 días. No para "ganar más".
              Para dejar de ser peligroso para ti.
            </p>
            <a href="https://pay.hotmart.com/I104339970M" target="_blank" rel="noopener noreferrer" className="self-start px-8 py-3 border border-[#d4af37] text-[#d4af37] hover:bg-[#d4af37] hover:text-black transition-colors duration-300 uppercase tracking-wider text-sm font-bold" data-id="element-294">
              Descargar Ahora
            </a>
          </div>
        </div>
      </div>
    </section>;
}